export const globalKeysES_MX = {
	important: "Importante",
	clean: "Limpiar",
	export: "Exportar",
	downloadExcel: "Descargar en Excel",
	import: "Importar",
	name: "Nombre",
	cancel: "Cancelar",
	code: "Código",
	goBack: "Volver",
	group: "Agrupar",
	filter: "Filtrar",
	goFoward: "Avanzar",
	next: "Siguiente",
	confirm: "Confirmar",
	yes: "Sí",
	no: "No",
	yesCaps: "SÍ",
	noCaps: "NO",
	truthCaps: "VERDADERO",
	falseCaps: "FALSO",
	all: "Todos",
	download: "Descargar",
	grams: "gramos",
	kilos: "Kilos",
	liter: "Litros",
	loading: "Cargando",
	by: "por",
	transfer: "Transferir",
	notTested: "No probado",
	tested: "Probado",
	error: "Error",
	delete: "Eliminar",
	finished: "Concluido",
	edit: "Editar",
	add: "Agregar",
	conclude: "Concluir",
	erase: "Borrar",
	remove: "Eliminar",
	restore: "Restaurar",
	search: "Buscar",
	duplicate: "Duplicar",
	sendMessageNow: "Enviar mensaje ahora",
	message: "Mensaje",
	messages: "Mensajes",
	and: "y",
	more: "más",
	gender: {
		male: "Hombre",
		female: "Mujer",
		others: "Otros",
	},
	daysOfTheWeek: {
		monday: "Lunes",
		tuesday: "Martes",
		wednesday: "Miércoles",
		thursday: "Jueves",
		friday: "Viernes",
		saturday: "Sábado",
		sunday: "Domingo",
		mon: "Lun",
		tue: "Mar",
		wed: "Mié",
		thu: "Jue",
		fri: "Vie",
		sat: "Sáb",
		sun: "Dom",
	},
	months: {
		january: "Enero",
		february: "Febrero",
		march: "Marzo",
		april: "Abril",
		may: "Mayo",
		june: "Junio",
		july: "Julio",
		august: "Agosto",
		september: "Septiembre",
		october: "Octubre",
		november: "Noviembre",
		december: "Diciembre",
	},
	new: "Nuevo",
	order: "Ordenar",
	period: "Período",
	phone: "Teléfono",
	phoneInternational: "Teléfono (solo internacional)",
	preview: "Visualizar",
	seeAttachments: "Ver adjuntos",
	previous: "Anterior",
	print: "Imprimir",
	printReport: "Imprimir informe",
	reload: "Recargar",
	request: "Solicitar",
	requiredField: "Campo Obligatorio",
	save: "Guardar",
	seeLess: "Ver menos",
	seeMore: "Ver más",
	select: "Seleccione",
	selected: "Seleccionado",
	selectedPlural: "Seleccionados",
	send: "Enviar",
	shortMonths: {
		jan: "Ene",
		feb: "Feb",
		mar: "Mar",
		apr: "Abr",
		may: "May",
		jun: "Jun",
		jul: "Jul",
		aug: "Ago",
		sep: "Sep",
		oct: "Oct",
		nov: "Nov",
		dec: "Dic",
	},
	typeHere: "Escriba aquí",
	continue: "Continuar",
	close: "Cerrar",
	tryAgain: "Intentar nuevamente",
	attention: "Atención",
	create: "Crear",
	days: "Días",
	exclude: "Excluir",
	from: "De",
	to: "Para",
	value: "Valor",
	day: "Día",
	month: "Mes",
	category: "Categoría",
	true: "Verdadero",
	false: "Falso",
	issue: "Emitir",
	currencies: {
		real: "Real",
		dollar: "Dólar",
		mexPeso: "Peso mexicano",
		euro: "Euro",
	},
	newRole: "Nuevo cargo",
	comingSoon: "Próximamente",
	pending: "Pendiente",
	invalid: "Inválido",
	today: "Hoy",
	yesterday: "Ayer",
	tomorrow: "Mañana",
	disable: "Desactivar",
	disabled: "Desactivado",
	daysOfTheWeekComplete: {
		monday: "Lunes",
		tuesday: "Martes",
		wednesday: "Miércoles",
		thursday: "Jueves",
		friday: "Viernes",
		saturday: "Sábado",
		sunday: "Domingo",
		holidays: "Feriados",
	},
	daysOfTheWeekSmall: {
		mon: "Lun",
		tue: "Mar",
		wed: "Mié",
		thu: "Jue",
		fri: "Vie",
		sat: "Sáb",
		sun: "Dom",
		hol: "Fer",
	},
	typeDate: {
		Day: "Día",
		Week: "Semana",
		Month: "Mes",
		Year: "Año",
	},
	typeDatePlural: {
		Days: "Días",
		Weeks: "Semanas",
		Months: "Meses",
		Years: "Años",
	},
	upload: "Subir",
	leave: "Salir",
	toSelect: "Seleccionar",
	cpf: "CPF",
	promoter: "Promotor",
	unknown: "Anónimo",
	uid: "Zig Code",
	withoutPermission: "No tienes permisos",
	exportPdf: "Exportar a PDF",
	exportExcel: "Exportar a Excel",
	withoutPermissionToViewPage: "No tienes permiso para acceder a esta página",
	update: "Actualizar",
	enable: "Activar",
	enabled: "Activado",
	dataSavedSuccess: "Datos guardados con éxito",
	successfullExportMsg: "Exportación realizada con éxito",
	backToMainPage: "Volver a la página principal",
	somethingWentWrong: "Ups... Algo no salió como estaba planeado.",
	savingData: "Guardando datos",
	subtotal: "Subtotal",
	total: "Total",
	type: "Tipo",
	invalidEmail: "Email inválido",
	emptyText: "Sin datos para mostrar.",
	of: "de",
	noneOfTheOptions: "Ninguna de las opciones",
	transaction: "Transacción",
	page: "página",
	recharge: "Recarga",
	applyFilter: "Aplicar filtro",
	date: "Fecha",
	since: "Desde",
	until: "Hasta",
	paginationTotal: "{{start}}-{{end}} de {{total}}",
};
